<template>
  <label class="checkbox mb-0 flex self-center">
    <span class="sr-only">{{ label }}</span>
    <input type="checkbox" :value="value" :checked="checked" :disabled="disabled" @change="onChange" />
    <span class="control-indicator"></span>
  </label>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    disabled: Boolean,
    checked: Boolean,
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  watch: {
    checked(val) {
      this.$emit('change', val);
    },
  },
  methods: {
    onChange(event) {
      event.stopPropagation();
      this.$emit('change', event.target.checked);
    },
  },
};
</script>
